import { Button, Menu } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { iconProps } from 'components/icon-props';
import { i18nKeys, useTranslation } from 'locales';
import { MAIL_CATEGORY_COLORS, MAIL_CATEGORY_LABELS, type MailCategory } from 'modules/Mails/types';
import { useUpdateMail } from 'shared/hooks/use-update-mail';
import { CategoryDot } from './CategoryDot';

type AddCategoryMenuProps = {
  availableCategories: MailCategory[];
  onAdd: (category: MailCategory) => void;
};

export const AddCategoryMenu = ({ availableCategories, onAdd }: AddCategoryMenuProps) => {
  const { t } = useTranslation();
  const { isUpdateMailLoading } = useUpdateMail();

  if (availableCategories.length === 0) return null;

  return (
    <Menu shadow="md" width={240} position="bottom-start" withinPortal>
      <Menu.Target>
        <Button
          variant="default"
          color="gray"
          size="compact-xs"
          leftSection={<IconPlus {...iconProps(11)} />}
          disabled={isUpdateMailLoading}
          styles={{ root: { borderStyle: 'dashed' } }}
        >
          {t(i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.ADD_TAG)}
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        {availableCategories.map(category => (
          <Menu.Item
            key={category}
            onClick={() => onAdd(category)}
            leftSection={<CategoryDot color={MAIL_CATEGORY_COLORS[category]} />}
          >
            {t(MAIL_CATEGORY_LABELS[category])}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};
